<template>
	<div
		class="value-wrapper"
	>
		<input
			:id="availableValue.id"
			v-model="localModel" class="value-input"
			type="radio"
			:name="name"
			:value="availableValue.id"
		>
		<label class="value-label" :for="availableValue.id">
			<span
				class="value-preview"
				:class="{'value-preview--with-border': availableValue.isPreviewWithBorder}"
				:style="`background: ${availableValue.color}`"
			/>
			<span class="visually-hidden">{{ availableValue.name }}</span>
		</label>
	</div>
</template>

<script>
import { computed } from 'vue';

export default {
	name: 'DesignRadio',
	props: {
		availableValue: {
			type: Object,
			required: true,
		},
		name: {
			type: String,
			required: true,
		},
		model: {
			type: String,
			required: true,
		},
	},
	setup(props, { emit }) {
		const localModel = computed({
			get: () => props.model,
			set: () => emit('update:model', props.availableValue.payload),
		});

		return {
			localModel,
		};

	},
};
</script>

<style lang="sass" scoped>
@import "@/assets/styles.sass"

.value-wrapper
	display: flex
	margin-right: 20px

	&:last-child
		margin-right: 0

	&:hover
		.value-label:after
			opacity: 1

.value-label
	position: relative

	box-sizing: border-box
	width: 40px
	height: 40px

	background-color: #ffffff

	border-radius: 50%

	cursor: pointer

	transition: border-color 0.3s

	&:after
		position: absolute
		content: ''
		top: -1px
		left: -1px

		box-sizing: border-box
		width: 42px
		height: 42px

		border: 2px solid #FF3021
		border-radius: 50%

		opacity: 0

		transition: opacity 0.2s

.value-preview
	position: absolute
	top: 3px
	left: 3px

	display: block
	width: 34px
	height: 34px
	box-sizing: border-box
	border-radius: 50%

	border: 1px solid transparent


.value-preview--with-border
	border-color: #DCDCDC



.value-input
	display: none

	&:checked ~ .value-label:after
		opacity: 1
</style>
